import { css, html } from 'lit'
import { Task } from '@lit/task';
import { ParentPico } from '../parent-pico/parent-pico.ts'
import { customElement, property, state } from 'lit/decorators.js'
// import { UserAgent } from '../../modules/fingerprint/user-agent.ts';
// import { HyperSelectPico } from '../hyper-select/hyper-select-pico.ts';
// import { ContactPico } from '../contact/contact-pico.ts';
import { fetchMakes, fetchModels, fetchParts } from '../../lib/partservice.ts';
/**
 * An example element.
 *
 * @slot - This element has a slot
 * @csspart button - The button
 */
@customElement('parts-form-pico')
export class PartsFormPico extends ParentPico {

  @state()
  selections = {
    "year": "",
    "make": "",
    "model": "",
    "part": "",
    "firstname": "",
    "lastname": "",
    "email": "",
    "phone": "",
    "comments": ""
  }

  @property({ type: Array }) data?: Array<string>;
  @property({ type: Array }) models?: Array<string>;
  @property({ type: Array }) parts?: Array<string>;
  @property({ type: String }) yearInvalid?: string = "";
  @property({ type: String }) makeInvalid?: string = "";
  @property({ type: String }) modelInvalid?: string = "";
  @property({ type: String }) partInvalid?: string = "";
  @property({ type: String }) emailInvalid?: string = "";
  @property({ type: String }) phoneInvalid?: string = "";


  constructor() {
    super();
    this._initializeEventListeners();
  }


  private async _initializeEventListeners(this: PartsFormPico) {
    this.addEventListener('Select Year', (e: Event) => {
      this.selections.year = (e as CustomEvent).detail.value
      this.yearInvalid = "false";
    });
    this.addEventListener('Select Make', async (e: Event) => {
      this.selections.make = (e as CustomEvent).detail.value;
      this.models = await fetchModels(this.selections.make);
      this.selections.model = "";
      this.makeInvalid = "false";

    });
    this.addEventListener('Select Model', async (e: Event) => {
      this.selections.model = (e as CustomEvent).detail.value
      this.parts = await fetchParts();
      this.modelInvalid = "false";

    });
    this.addEventListener('Select Part', (e: Event) => {
      this.selections.part = (e as CustomEvent).detail.value
      this.partInvalid = "false";
    });

    this.addEventListener('Contact', (e: Event) => {
      const detail = (e as CustomEvent).detail;
      this.selections[detail.id as keyof typeof this.selections] = detail.value;
    });
  }



  private _years = Array.from({ length: 30 }, (_, i) => (new Date().getFullYear() - i).toString());

  private _dataTask = new Task(
    this,
    {
      // task: async ([data], { signal }) => {
      task: async ([], { }) => {
        return await fetchMakes();
        console.log("Fetching make data");
        // return ["Acura", "Alfa Romeo", "Aston Martin", "Audi", "Bentley", "BMW", "Buick", "Cadillac", "Chevrolet", "Chrysler", "Dodge", "Ferrari", "Fiat", "Ford", "Genesis", "GMC", "Honda", "Hyundai", "Infiniti", "Jaguar", "Jeep", "Kia", "Lamborghini", "Land Rover", "Lexus", "Lincoln", "Lotus", "Maserati", "Mazda", "McLaren", "Mercedes-Benz", "MINI", "Mitsubishi", "Nissan", "Porsche", "Ram", "Rolls-Royce", "Subaru", "Tesla", "Toyota", "Volkswagen", "Volvo"]
      },
      args: () => [this.data]
    });

  private async _submitLead() {
    // console.log(this.selections);
    this._validateForm();
    this.dispatchEvent(new CustomEvent('lead-submitted', {
      detail: {
        selections: this.selections,
        timestamp: new Date().toISOString()
      },
      bubbles: true,
      composed: true
    }));
    // const headers = new Headers();
    // headers.append("Content-Type", "application/json");

    // await fetch("/postLead", {
    //   method: "POST",
    //   body: JSON.stringify(this.selections),
    //   headers: headers,
    // });

  }

  private _validateForm() {
    if (this.selections.year == "") {
      this.yearInvalid = "true";
    }
    if (this.selections.make == "") {
      this.makeInvalid = "true";
    }
    if (this.selections.model == "") {
      this.modelInvalid = "true";
    }
    if (this.selections.part == "") {
      this.partInvalid = "true";
    }

  }


  render() {
    // console.log((new UserAgent(window)).getUserAgent());

    //TODO Scope for increaseing the performance. p
    //Pass the JSON data directly instead of remapping to array
    //and let hyper-select-pico render the data

    return html`
    ${this._dataTask.render({
      initial: () => html`<p>Waiting to start task</p>`,
      pending: () => html`<p>Running task...</p>`,
      complete: (makes) =>
        html`
          <section><slot name="header"></slot></section>
          <section>
              <hyper-select-pico placeholder="Select Year"  .invalid=${this.yearInvalid}  .items=${this._years}></hyper-select-pico>
              <hyper-select-pico placeholder="Select Make"  .invalid=${this.makeInvalid}  .items=${makes}></hyper-select-pico>
              <hyper-select-pico placeholder="Select Model" .invalid=${this.modelInvalid} .items=${this.models}></hyper-select-pico>
              <hyper-select-pico placeholder="Select Part"  .invalid=${this.partInvalid} .items=${this.parts}></hyper-select-pico>
          </section>
          <section>
                        <contact-pico></contact-pico>
              
              <input type="button"   @click=${() => this._submitLead()}  value="Get A Quote">
         
          </section>`,
      error: (error) => html`<p>Oops, something went wrong: ${error}</p>`,
    })}
  `;


  }

  /* <div class="container">
    <div class="columns is-centered is-vcentered">
    <div class="column ">
        
        
      </div>
      </div>
   </div> */


  static styles = [
    ParentPico.styles,
    css`
      :host {
        display: block;
        padding: 1rem;
      }

      section{
        margin-bottom:0;
      }

      @media(min-width: 768px) {
      section + section{
      width:100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: .1rem .5rem ;
      justify-content: center;
      }
  }
         
       `
  ]
}

declare global {
  interface HTMLElementTagNameMap {
    'parts-form-pico': PartsFormPico
  }
}
